import { formatDay } from 'core/utils/dates';

const MISSING = '—';

const isMissing = (value: number | '' | null | undefined): value is '' | null | undefined =>
  value === '' || value === null || value === undefined || Number.isNaN(Number(value));

export const formatSubsidiaryAmount = (value: number | '' | null | undefined): string =>
  isMissing(value)
    ? MISSING
    : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }).format(Number(value));

export const formatSubsidiaryCount = (value: number | '' | null | undefined): string =>
  isMissing(value) ? MISSING : new Intl.NumberFormat('fr-FR').format(Number(value));

// Calendar date: string slicing only, no time zone conversion.
export const formatSubsidiaryDate = (value?: string | null): string => (value ? formatDay(value) : MISSING);
